import React from "react";

const IRefresh = ({
  color = "#252526",
  width = "12",
  height = "12",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M0 10.7917V7.58333C0 7.26117 0.261167 7 0.583333 7H3.79167C4.11383 7 4.375 7.26117 4.375 7.58333C4.375 7.9055 4.11383 8.16667 3.79167 8.16667H1.16667V10.7917C1.16667 11.1138 0.905499 11.375 0.583333 11.375C0.261167 11.375 0 11.1138 0 10.7917Z"
        fill={color}
      />
      <path
        d="M11.375 0.583333V3.79167C11.375 4.11383 11.1138 4.375 10.7917 4.375H7.58333C7.26117 4.375 7 4.11383 7 3.79167C7 3.4695 7.26117 3.20833 7.58333 3.20833H10.2083V0.583333C10.2083 0.261167 10.4695 0 10.7917 0C11.1138 0 11.375 0.261167 11.375 0.583333Z"
        fill={color}
      />
      <path
        d="M0 5.54167C0 3.30425 1.34791 1.28584 3.41284 0.426107C4.08801 0.145018 4.81301 3.53424e-05 5.54451 0H5.64534C7.63885 0 9.50415 0.982475 10.6322 2.62614L11.2725 3.55868L10.3109 4.21891L9.67057 3.28638C8.76014 1.95975 7.25433 1.16667 5.64534 1.16667H5.54451C4.96709 1.1667 4.39439 1.28134 3.86117 1.50334C2.23063 2.18228 1.16667 3.77605 1.16667 5.54167C1.16667 5.86383 0.905499 6.125 0.583333 6.125C0.261167 6.125 7.51631e-08 5.86383 0 5.54167Z"
        fill={color}
      />
      <path
        d="M11.375 5.83333C11.375 8.07075 10.0271 10.0892 7.96216 10.9489C7.28699 11.23 6.56199 11.375 5.83048 11.375H5.72965C3.73615 11.375 1.87085 10.3925 0.742839 8.74886L0.102539 7.81632L1.06413 7.15609L1.70443 8.08862C2.61486 9.41525 4.12067 10.2083 5.72965 10.2083H5.83048C6.40791 10.2083 6.98061 10.0937 7.51383 9.87166C9.14437 9.19272 10.2083 7.59895 10.2083 5.83333C10.2083 5.51117 10.4695 5.25 10.7917 5.25C11.1138 5.25 11.375 5.51117 11.375 5.83333Z"
        fill={color}
      />
    </svg>
  );
};

export default IRefresh;
